//region :: Imports ::
import React, {Component, MouseEventHandler, ReactElement} from 'react';
import {classNames} from 'primereact/utils';
import MTopbarButton from './TopbarButton';
import {Link} from 'react-router-dom';
import {IMsalContext, MsalContext} from '@azure/msal-react';
import {MNullable} from '../../Utils';

//endregion

/** */
type Props = {
    appTitle: string;
    actionButtons: ReactElement<MTopbarButton>[];
    isActionsMenuVisible: boolean;
    onActionsMenuClick?: MouseEventHandler<HTMLButtonElement>;
}

/** */
class MTopbar extends Component<Props> {

    static contextType = MsalContext;
    private m_context: MNullable<IMsalContext>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.m_context = null;

    }

    /** */
    private bindMethods(): void {
        this.logoutButton_onClick = this.logoutButton_onClick.bind(this);
    }

    /** */
    private async logoutButton_onClick(): Promise<void> {

        const activeAccount = this.m_context!.instance.getActiveAccount();

        if(activeAccount === null) {
            throw new Error('No logged in user.');
        }

        await this.m_context!.instance.logout({account: activeAccount});

    }

    /** */
    public componentDidMount(): void {
        this.m_context = this.context as IMsalContext;
    }

    /** */
    public render(): ReactElement {

        const environment = process.env.REACT_APP_ENVIRONMENT;
        const isProd = environment === 'azprod';
        const actionButtons = [...this.props.actionButtons];

        actionButtons.push(
            <MTopbarButton label="Logout"
                           icon="pi-sign-out"
                           onClick={this.logoutButton_onClick}/>
        );

        return (
            <div className="mshell-topbar">

                {/* Logo */}
                <div className="mshell-topbar-logo">
                    <img src="/logo.png" alt="logo"/>
                    <Link to="/" className="mtext-color-secondary">
                        {this.props.appTitle}{isProd ? null : <span className="text-sm"> ({environment})</span>}
                    </Link>
                </div>

                {/* Actions Menu Button */}
                <button type="button"
                        className="p-link mshell-topbar-button mshell-topbar-actionsmenu-button"
                        onClick={this.props.onActionsMenuClick}>
                    <i className="pi pi-ellipsis-v"/>
                </button>

                {/* Actions Menu */}
                <ul className={classNames('mshell-topbar-actionsmenu lg:flex origin-top', {'mshell-topbar-actionsmenu-mobile-active': this.props.isActionsMenuVisible})}>
                    {actionButtons.map((button: ReactElement<MTopbarButton>, index: number) => {

                        return (
                            <li key={index}>
                                {button}
                            </li>
                        );

                    })}
                </ul>

            </div>
        );

    }

}

export default MTopbar;
